import React from "react";
import { Helmet } from "react-helmet";
import { PageShell } from "./ui/PageShell";
import { Eyebrow } from "./ui/Eyebrow";
import { PrimaryLink, SecondaryLink } from "./ui/Buttons";

/**
 * Catch-all route. React Router only controls what renders client-side —
 * the Netlify SPA rewrite (`public/_redirects`: `/* /index.html 200`) still
 * serves this with an HTTP 200, not a real 404. `noindex` keeps it out of
 * the index regardless of status code; a true HTTP 404 would require a
 * deployment-level change (e.g. an edge function or redirect rule), which
 * is outside this phase's scope.
 */
const NotFound = () => {
  return (
    <>
      <Helmet>
        <title>Page Not Found | Advanced Automotive Smog</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>

      <PageShell className="bg-[#F8F9FA] text-slate-700">
        <div className="mx-auto flex min-h-[60vh] max-w-3xl flex-col items-center justify-center px-4 py-16 text-center sm:px-5">
          <Eyebrow tone="light" className="mb-4">
            Advanced Automotive · 404
          </Eyebrow>

          <h1 className="text-[1.65rem] font-semibold leading-snug tracking-tight text-navy-900 sm:text-3xl md:text-4xl">
            We couldn&apos;t find that page
          </h1>

          <p className="mt-4 max-w-xl text-sm leading-relaxed text-slate-700 sm:text-base">
            The page you&apos;re looking for may have moved or no longer exists.
            Head back to the homepage or browse our full list of services.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <PrimaryLink to="/" className="px-8 py-3 text-base">
              Back to homepage
            </PrimaryLink>
            <SecondaryLink to="/services" className="px-8 py-3 text-base">
              Browse services
            </SecondaryLink>
          </div>
        </div>
      </PageShell>
    </>
  );
};

export default NotFound;
